import router from "@/router/index";
import {ACCESS_TOKEN} from "@/enum/enum";


router.beforeEach((to, from, next) => {
    if (!localStorage.getItem(ACCESS_TOKEN) && to.path !== '/login'){
        next({path:'/login'})
    }else{
        next()
    }
})